import { render, staticRenderFns } from "./WebContent.vue?vue&type=template&id=372aada4&scoped=true&"
import script from "./WebContent.vue?vue&type=script&lang=js&"
export * from "./WebContent.vue?vue&type=script&lang=js&"
import style0 from "./WebContent.vue?vue&type=style&index=0&id=372aada4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372aada4",
  null
  
)

export default component.exports